import React from 'react'
import { withIcon } from '../../withIcon'

function ChevronUpIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M11.1831 8.44702C11.4271 8.19507 11.8229 8.19507 12.0669 8.44702L18.0669 14.6406C18.311 14.8925 18.311 15.301 18.0669 15.553C17.8229 15.8049 17.4271 15.8049 17.1831 15.553L11.625 9.81561L6.06694 15.553C5.82286 15.8049 5.42714 15.8049 5.18306 15.553C4.93898 15.301 4.93898 14.8925 5.18306 14.6406L11.1831 8.44702Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ChevronUpIcon)
